<template>
  <div class="mobile-slider">
    <OrisSwiper
      :modules="modules"
      :pagination="{ enabled: true, clickable: true }"
      @slide-changed="onSlideChange"
    >
      <SwiperSlide v-for="(image, index) in images" :key="`${images}_${index}`">
        <slot name="image" v-bind="image" />
      </SwiperSlide>
    </OrisSwiper>
  </div>
</template>

<script
  setup
  lang="ts"
  generic="
    T extends
      | ParagraphPdpStageImageFragment
      | ParagraphPdpStageVideoFragment
      | { url: string }
  "
>
import { SwiperSlide } from 'swiper/vue'
import { Pagination } from 'swiper/modules'
import type {
  ParagraphPdpStageImageFragment,
  ParagraphPdpStageVideoFragment,
} from '#build/graphql-operations'

const modules = [Pagination]

defineProps<{
  images: T[]
}>()

const emit = defineEmits<{
  slideChanged: []
}>()

defineSlots<{
  image(props: T): void
}>()

const onSlideChange = () => {
  emit('slideChanged')
}
</script>

<style lang="scss" scoped>
/* stylelint-disable no-invalid-position-at-import-rule */

:deep() {
  @import 'swiper/scss';
  @import 'swiper/scss/navigation';
  @import 'swiper/scss/pagination';
  @import 'swiper/scss/scrollbar';
}

.mobile-slider {
  height: 100%;
}

:deep(.swiper) {
  height: 100%;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .swiper-pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 25px;
    padding-inline: 16px;
  }

  .swiper-pagination-bullet {
    background-color: transparent;
    transition: all 0.3s ease-out;
    margin-inline: 4px;
    height: 2em;
    display: flex;
    flex: 1;
    padding: 0;
    opacity: 1;

    &::after {
      height: 50%;
      background-color: transparent;
      flex: 1;
      content: '';

      @apply border-b-grey-dark-02;

      border-radius: 0%;
      border-width: 0 0 2px 0;
    }

    &-active {
      flex: 2;

      &::after {
        height: 50%;
        content: '';
        border-bottom: 2px solid white;
        border-width: 0 0 2px 0;
        /* stylelint-disable-next-line declaration-property-value-no-unknown */
        background-color: none;
        border-radius: 0%;
      }
    }
  }
}
</style>
